import { getPerfectScrollbarMaxTop } from "./perfectScrollbarScrollMetrics";

const activeScrollAnimations = new WeakMap();

const easeInOutCubic = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;

/**
 * 以 ease-in-out 平滑捲動元素（含 PerfectScrollbar 容器）。
 * @param {HTMLElement} element
 * @param {number} targetTop
 * @param {{ duration?: number, contentEl?: HTMLElement | null, maxScrollTop?: number }} [options]
 */
export function smoothScrollElementTo(element, targetTop, options = {}) {
  if (!element) return;

  const duration = options.duration ?? 400;
  const maxTop =
    options.maxScrollTop ??
    getPerfectScrollbarMaxTop(element, options.contentEl);
  const clampedTarget = Math.max(0, Math.min(targetTop, maxTop));

  const prev = activeScrollAnimations.get(element);
  if (prev) cancelAnimationFrame(prev.rafId);

  const startTop = element.scrollTop;
  const distance = clampedTarget - startTop;
  if (Math.abs(distance) < 1) {
    element.scrollTop = clampedTarget;
    return;
  }

  const startTime = performance.now();
  const state = { rafId: 0 };
  activeScrollAnimations.set(element, state);

  const step = (now) => {
    const progress = Math.min((now - startTime) / duration, 1);
    element.scrollTop = startTop + distance * easeInOutCubic(progress);
    if (progress < 1) {
      state.rafId = requestAnimationFrame(step);
    } else {
      element.scrollTop = clampedTarget;
      activeScrollAnimations.delete(element);
    }
  };

  state.rafId = requestAnimationFrame(step);
}

export function smoothScrollContainerEdge(root, edge, options) {
  if (!root) return;
  const psElement = root.querySelector(':scope > .ps__element');
  const el =
    psElement ||
    (root.classList?.contains('ps') ||
    root.classList?.contains('scrollbar-container') ||
    root.classList?.contains('pr-perfect-scrollbar')
      ? root
      : root.querySelector('.ps') || root);
  const contentEl =
    options?.contentEl ?? el.querySelector(':scope > .ps__content');
  const top =
    edge === 'top' ? 0 : getPerfectScrollbarMaxTop(el, contentEl);
  smoothScrollElementTo(el, top, { ...options, contentEl });
}
